import React from 'react';
import { Link } from 'react-router-dom';
import { motion, useReducedMotion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import { ArrowButton } from '../ui/ArrowButton';
import { cardImage, heroImage } from '../../data/home';
export function Hero() {
  const reduce = useReducedMotion();
  const ease = [0.23, 1, 0.32, 1] as const;
  return <section className="w-full bg-white" data-id="element-75" data-mp="aojw2pu2f2uw">
      <div className="mx-auto grid max-w-[1320px] items-center gap-12 px-6 pb-16 pt-12 lg:grid-cols-12 lg:pb-20 lg:pt-16" data-id="element-76" data-mp="apl6cs39blbk">
        <div className="lg:col-span-6" data-id="element-77" data-mp="5o5mh3ctfkur">
          <p className="text-[15px] font-medium text-brand" data-id="element-78" data-mp="q43eife3lja">Banque mauritanienne depuis 1972</p>
          <motion.h1 initial={reduce ? false : {
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          ease
        }} className="font-display mt-5 text-[64px] text-ink sm:text-[88px] xl:text-[112px]" data-id="element-79" data-mp="3rwx47l69tina">
            Vos projets
            <br data-id="element-80" data-mp="1mwm1pyy9nq5y" />
            méritent une
            <br data-id="element-81" data-mp="1murgskmzvy1v" />
            <span className="text-brand" data-id="element-82" data-mp="1myfbhn46eqi6">vraie banque</span>
          </motion.h1>
          <p className="mt-7 max-w-md text-[17px] leading-relaxed text-ink-muted" data-id="element-83" data-mp="1rx0dns2znk99">
            Comptes, épargne islamique, crédits et banque en ligne : Chinguitty Bank accompagne particuliers et
            entreprises partout en Mauritanie.
          </p>
          <div className="mt-9 flex flex-wrap items-center gap-3" data-id="element-84" data-mp="25n3pdp48rvkg">
            <ArrowButton to="/devenir-client" data-id="element-85" data-mp="25owydb2burvm">Devenir client</ArrowButton>
            <ArrowButton to="/acces-comptes" variant="outline" data-id="element-86" data-mp="2aldp8d0wvkce">
              Accès à vos comptes
            </ArrowButton>
          </div>
        </div>

        <div className="relative lg:col-span-6" data-id="element-87" data-mp="20vu6d7d77qhj">
          <div className="relative aspect-[4/5] overflow-hidden rounded-[32px] bg-[#EEEEEC] sm:aspect-[5/5] lg:aspect-[4/4.6]" data-id="element-88" data-mp="20uiyowgmtyl5">
            <img src={heroImage} alt="Cliente souriante consultant son compte Chinguitty Bank sur son téléphone" className="absolute inset-0 h-full w-full object-cover object-[50%_18%]" data-id="element-89" data-mp="2ojvbe6b64os7" />
          </div>

          <motion.img initial={reduce ? false : {
          opacity: 0,
          x: -16,
          rotate: -14
        }} animate={{
          opacity: 1,
          x: 0,
          rotate: -10
        }} transition={{
          duration: 0.3,
          delay: 0.1,
          ease
        }} src={cardImage} alt="Carte bancaire Chinguitty Bank" className="absolute -left-6 bottom-24 hidden w-44 rounded-2xl mix-blend-multiply sm:block lg:-left-14" data-id="element-90" data-mp="2yalmikk3djy6" />

          <Link to="/particuliers/compte-el-hacad" className="group absolute bottom-5 right-5 flex max-w-[280px] items-center gap-4 rounded-2xl bg-white/95 p-4 shadow-[0_16px_40px_-16px_rgba(16,21,18,0.35)] backdrop-blur transition-transform duration-200 ease-out hover:-translate-y-0.5" data-id="element-91" data-mp="2fhhraur86z1g">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gold-light font-arabic text-[13px] font-bold text-[#8A6B0E]" data-id="element-92" data-mp="1wjyedg1ncw9r">
              الحصاد
            </span>
            <span className="min-w-0" data-id="element-93" data-mp="h10ho7342ba4">
              <span className="block text-[12px] font-medium text-gold" data-id="element-94" data-mp="gzxt45t9gkxd">Nouveau · Produit islamique</span>
              <span className="block text-[15px] font-semibold text-ink" data-id="element-95" data-mp="m14xrw03x3zt">Compte El-Haçad</span>
            </span>
            <ArrowUpRightIcon className="h-5 w-5 shrink-0 text-ink transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" data-id="element-96" data-mp="q15e5m6rnp9i" />
          </Link>
        </div>
      </div>
    </section>;
}